import { render, staticRenderFns } from "./limitSalesGoodsAction.vue?vue&type=template&id=47af20c8&scoped=true"
import script from "./limitSalesGoodsAction.vue?vue&type=script&lang=js"
export * from "./limitSalesGoodsAction.vue?vue&type=script&lang=js"
import style0 from "./limitSalesGoodsAction.vue?vue&type=style&index=0&id=47af20c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af20c8",
  null
  
)

export default component.exports